/**
 * Compact info about a course playlist (used in the multi-selects and in the course summary in the collapsible table).
 */

import React from 'react'
import {useStyles} from "./CoursePlaylistCard.css";
import {PlaylistPlay} from "@mui/icons-material";
import {Chip, Tooltip} from "@mui/material";
import ScoredScenesInPlaylistSection from "../../../playlists/scoredScenesSummary/ScoredScenesInPlaylistSection";
import {FormattedMessage} from "react-intl";
import FeedbackModeIndication from "../../../playlists/utils/FeedbackModeIndication";
import PlaylistStatusIndication from "../../../playlists/utils/PlaylistStatusIndication";

const CoursePlaylistCard = ({playlist, showInfo, ...props}) => {
    const classes = useStyles()

    return (
        <Chip {...props} className={classes.chip} label={
            <div className={classes.row}>
                <div>
                    {showInfo &&
                    <Tooltip placement="bottom" classes={{tooltip: classes.noMaxWidth}}
                             title={<ScoredScenesInPlaylistSection playlistKey={playlist.key}/>}>
                        <PlaylistPlay className={classes.previewIcon}/>
                    </Tooltip>}
                </div>

                <div className={classes.column}>

                    {/* Playlist name */}
                    <div className={classes.name}>
                        {playlist.name}
                    </div>

                    {/* Number of scored scenes included in the playlist */}
                    <div className={classes.additionalInfo}>
                        <FormattedMessage id={'app.courses.utils.scoredScenesInPlaylist'}
                                          defaultMessage='{n, plural, one {<code>1</code> video scene included} other {<code>{n}</code> video scenes included}}'
                                          values={{
                                              n: playlist.scoredScenesKeys?.length || playlist.scoredScenes?.length,
                                              code: (component) => <b>{component}</b>
                                          }}/>
                    </div>
                </div>

                <div className={classes.playlistInfoContainer}>
                    <FeedbackModeIndication feedbackMode={playlist.feedbackMode}/>
                    <PlaylistStatusIndication playlist={playlist}/>
                </div>
            </div>}/>
    )
}
export default CoursePlaylistCard
